// 获取对应租户的筛选项
export const getSearchParams = (tenantCode) => {
    switch (tenantCode) {
        //圆通
        case 13:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'reportId',
                    label: '报案单号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的身份证'
                },
                {
                    value: 'policyNo',
                    label: '保单号'
                },
                {
                    value: 'reporterName',
                    label: '报案人姓名'
                },

                {
                    value: 'reporterCellPhone',
                    label: '报案人电话'
                },
                {
                    value: 'insuredName',
                    label: '被保人姓名'
                },
                {
                    value: 'claimNo',
                    label: '赔案号'
                },
                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                },
                {
                    value: 'websiteCode',
                    label: '网点代码'
                },
                {
                    value: 'websiteName',
                    label: '网点名称'
                },
            ];
        case 14:
        case 16:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'reportId',
                    label: '报案单号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的身份证'
                },
                {
                    value: 'policyNo',
                    label: '保单号'
                },
                {
                    value: 'reporterName',
                    label: '报案人姓名'
                },
                {
                    value: 'reporterCellPhone',
                    label: '报案人电话'
                },
                {
                    value: 'insuredName',
                    label: '被保人姓名'
                },
                {
                    value: 'claimNo',
                    label: '赔案号'
                },
                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                },
                {
                    value: 'policyOrderNo',
                    label: '投保订单号'
                }
            ]
        case 15:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'ownVin',
                    label: '车架号'
                },
                {
                    value: 'carOwnerName',
                    label: '车主姓名'
                },
                {
                    value: 'carOwnerCellPhone',
                    label: '车主手机号'
                },
                {
                    value: 'orderId',
                    label: '投保订单号'
                }
            ];
        case 17:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'policyNo',
                    label: '保单号'
                },
                {
                    value: 'uniquePolicyNo',
                    label: '互联网保单号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的证件号'
                },
                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                },
                {
                    value: 'reporterName',
                    label: '报案人姓名'
                }
            ];
        case 18:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'reportId',
                    label: '报案单号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的身份证'
                },
                {
                    value: 'policyNo',
                    label: '保单号'
                },
                {
                    value: 'insuredName',
                    label: '被保人姓名'
                },
                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                },
                {
                    value: 'insuredIdCardNo',
                    label: '被保人证件号'
                }
            ];
        case 19:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的身份证'
                },
                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                },
                {
                    value: 'orderId',
                    label: '投保订单号'
                },
                {
                    value: 'reportId',
                    label: '报案号'
                }
            ];
        case 20:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'policyNo',
                    label: '保单号'
                },
                {
                    value: 'reportId',
                    label: '报案号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的身份证'
                },
                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                },
                {
                    value: 'reporterName',
                    label: '报案人姓名'
                }
            ];
        case 21:
            return [

                {
                    value: 'reportId',
                    label: '报案号'
                },
                {
                    value: 'partnerClaimNo',
                    label: '饿了么理赔单'
                },
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'policyNo',
                    label: '保单号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的身份证'
                },

                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                },
                {
                    value: 'reporterName',
                    label: '报案人姓名'
                }
            ];
        default:
            return [
                {
                    value: 'flowId',
                    label: '受理号'
                },
                {
                    value: 'reportId',
                    label: '报案单号'
                },
                {
                    value: 'ownIdCardNo',
                    label: '标的身份证'
                },
                {
                    value: 'policyNo',
                    label: '保单号'
                },
                {
                    value: 'reporterName',
                    label: '报案人姓名'
                },
                {
                    value: 'reporterCellPhone',
                    label: '报案人电话'
                },
                {
                    value: 'insuredName',
                    label: '被保人姓名'
                },
                {
                    value: 'claimNo',
                    label: '赔案号'
                },
                {
                    value: 'ownCarLossName',
                    label: '标的姓名'
                }
            ];
    }
};
